import ClaimDetailsNew from './ClaimDetailsNew';
import Summary from './Summary';
import ClaimsWizard from './Wizard';

export { Summary, ClaimDetailsNew };

export default ClaimsWizard;
